module.exports = __webpack_public_path__ + "img/ems_charge_logo.e2d91eb9.png";